import once from 'lodash/once';
import { VIDEO_WATCHING_MODE } from '../../config/constants';
import trackVideoPlaying from '../track-event/video-playing';
import onVideoPlaying from '../../lib/dom/on-video-playing';
import trackVideoOpen from '../track-event/video-open';



export default (element, index = 0, mkParams = null) => {
  const trackActivate = once(trackVideoOpen);

  return onVideoPlaying(element, ({ mode, ...props }) => {
    const { activate = true, full_screen = true, video_id = index } = mkParams ? mkParams(index, props) : {};

    props = { ...props, is_video: true, gallery_slide_index: index, video_id, full_screen, screenshot_id: null };

    if (activate) {
      trackActivate(props);
    }

    if (mode !== VIDEO_WATCHING_MODE.ACTIVATE) {
      trackVideoPlaying(props);
    }
  });
};



// WEBPACK FOOTER //
// ./src/lib/bind-event-tracking/video-watching.js